export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('hb_user') || 'null');
  } catch {
    return null;
  }
};

export const getDoctor = () => {
  try {
    return JSON.parse(localStorage.getItem('hb_doctor') || 'null');
  } catch {
    return null;
  }
};

export const isUserLoggedIn = () => Boolean(localStorage.getItem('hb_token') && getUser());
export const isDoctorLoggedIn = () => Boolean(localStorage.getItem('hb_token') && getDoctor());

export const clearUserAuth = () => {
  localStorage.removeItem('hb_token');
  localStorage.removeItem('hb_refresh_token');
  localStorage.removeItem('hb_user');
  localStorage.removeItem('hb_doctor');
  localStorage.removeItem('hb_active_session');
};

